(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["unfold-floating-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('unfold-floating-hero')) {
  customElements.define('unfold-floating-hero', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.objects = [...this.querySelectorAll('[data-object]')];
      this.index = 0;
      this.glowIndex = 0;
      this.userPaused = false;
      this.hovered = false;
      this.visible = true;
      this.editing = false;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.dataset.preview = this.querySelector('.ufh__next-access')?.hidden ? 'false' : 'true';
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button.hasAttribute('data-next')) this.go(this.index + 1, true);
        if (button.hasAttribute('data-previous')) this.go(this.index - 1, true);
        if (button.hasAttribute('data-go')) this.go(Number(button.dataset.go), true);
        if (button.hasAttribute('data-pause')) {
          this.userPaused = !this.userPaused;
          button.setAttribute('aria-pressed', String(this.userPaused));
          button.setAttribute('aria-label', this.userPaused ? button.dataset.playLabel : button.dataset.pauseLabel);
          button.firstElementChild.textContent = this.userPaused ? '▶' : 'Ⅱ';
          this.schedule();
        }
      }, { signal });
      this.addEventListener('change', event => {
        if (!event.target.matches('input[type="radio"][name="id"]')) return;
        const input = event.target;
        const purchase = input.closest('[data-purchase]');
        const price = purchase.querySelector('span[data-price]');
        const compare = purchase.querySelector('s[data-compare]');
        if (price) price.textContent = input.dataset.price;
        if (compare) { compare.textContent = input.dataset.compare; compare.hidden = !input.dataset.compare; }
        purchase.querySelector('input[name="quantity"]').value = input.dataset.quantity;
      }, { signal });
      this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); } }, { signal });
      this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, { signal });
      this.addEventListener('focusin', () => this.schedule(), { signal });
      this.addEventListener('focusout', () => queueMicrotask(() => this.schedule()), { signal });
      this.addEventListener('keydown', event => {
        if (event.target.matches('input,select,textarea') || this.slides.length < 2) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
        }
      }, { signal });
      let touch;
      const stage = this.querySelector('.ufh__stage');
      stage?.addEventListener('touchstart', event => { touch = event.touches.length === 1 ? { x:event.touches[0].clientX,y:event.touches[0].clientY } : null; }, { passive:true,signal });
      stage?.addEventListener('touchend', event => {
        if (!touch || !event.changedTouches.length) return;
        const dx = event.changedTouches[0].clientX - touch.x;
        const dy = event.changedTouches[0].clientY - touch.y;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) this.go(this.index + (dx < 0 ? 1 : -1), true);
        touch = null;
      }, { passive:true,signal });
      document.addEventListener('visibilitychange', () => this.schedule(), { signal });
      this.reduced.addEventListener('change', () => this.schedule(), { signal });
      document.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index < 0) return;
        this.editing = true;
        this.go(index, false, true);
        this.schedule();
      }, { signal });
      document.addEventListener('shopify:block:deselect', event => {
        if (!this.slides.some(slide => slide.dataset.blockId === event.detail.blockId)) return;
        this.editing = false;
        this.schedule();
      }, { signal });
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); }, { threshold:.1 });
      this.observer.observe(this);
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.dataset.autoplay !== 'true' || this.slides.length < 2 || this.userPaused || this.hovered || this.editing || this.reduced.matches || !this.visible || document.hidden || this.contains(document.activeElement)) return;
      this.timer = setTimeout(() => this.go(this.index + 1), Number(this.dataset.interval));
    }
    go(next, manual = false, immediate = false) {
      if (!this.slides.length || (this.busy && !immediate)) return;
      next = (next + this.slides.length) % this.slides.length;
      if (next === this.index) { this.schedule(); return; }
      clearTimeout(this.timer);
      clearTimeout(this.release);
      this.busy = true;
      const old = this.index;
      this.index = next;
      const slide = this.slides[next];
      const glowLayers = this.querySelectorAll('[data-glow-layer]');
      this.glowIndex = 1 - this.glowIndex;
      glowLayers[this.glowIndex].style.background = `radial-gradient(ellipse at 50% 42%, ${slide.dataset.glow}, transparent 70%)`;
      glowLayers.forEach((layer,index) => layer.style.opacity = index === this.glowIndex ? '1' : '0');
      const variables = { bg:'bg',glow:'glow',text:'text',button:'button','button-text':'buttonText',scale:'scale','scale-mobile':'mobileScale' };
      Object.entries(variables).forEach(([property,key]) => this.style.setProperty('--ufh-' + property, slide.dataset[key]));
      this.querySelectorAll('[data-content],[data-purchase],[data-tagline]').forEach(panel => {
        const position = Number(panel.dataset.content ?? panel.dataset.purchase ?? panel.dataset.tagline);
        if (position !== next && panel.contains(document.activeElement)) {
          this.querySelector('[data-go="' + next + '"]')?.focus({ preventScroll:true });
        }
        panel.hidden = position !== next;
      });
      this.objects.forEach((object,index) => {
        object.dataset.pose = index === next ? 'active' : index === old ? 'exit' : index === (next + 1) % this.slides.length ? 'preview' : 'hidden';
      });
      this.querySelectorAll('[data-go]').forEach(button => button.setAttribute('aria-current', String(Number(button.dataset.go) === next)));
      if (manual) this.querySelector('[data-status]').textContent = slide.dataset.heading;
      this.release = setTimeout(() => {
        this.objects.forEach((object,index) => { object.dataset.pose = index === next ? 'active' : index === (next + 1) % this.slides.length ? 'preview' : 'hidden'; });
        this.busy = false;
        this.schedule();
      }, immediate || this.reduced.matches ? 0 : Number(this.dataset.duration));
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      clearTimeout(this.release);
      this.abort?.abort();
      this.observer?.disconnect();
      this.initialized = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
